import profile_500_webp from "./webp/profile-photo-500.webp";
import profile_1000_webp from "./webp/profile-photo-1000.webp";
// import profile_1500_webp from "./webp/profile-photo-1500.webp";
import profile_500_png from "./png/profile-photo-500.png";
import profile_1000_png from "./png/profile-photo-1000.png";
// import profile_1500_png from "./png/profile-photo-1500.png";

const profile = {
   png: {
      sm: profile_500_png,
      md: profile_1000_png
   },
   webp: {
      sm: profile_500_webp,
      md: profile_1000_webp
   }
};

export default profile;
